export const nosValeurs = [
    {
        text: 'Expertise',
        span: 'proactive',
        image: require('../img/icon-green-expertise.png'),
        image2: require('../img/icon-expertise.png')
    },
    {
        text: 'Accompagnement',
        span: 'humain',
        image: require('../img/icon-green-accompagnement.png'),
        image2: require('../img/icon-accompagnement.png')
    },
    {
        text: 'Rigueur',
        span: 'technique',
        image: require('../img/icon-green-rigueur.png'),
        image2: require('../img/icon-rigueur.png')
    },
    {
        text: 'Bienveillance',
        span: 'constructive',
        image: require('../img/icon-green-bienveillance.png'),
        image2: require('../img/icon-bienveillance.png')
    },
    {
        text: 'Excellence',
        span: 'continue',
        image: require('../img/icon-green-lexcellence.png'),
        image2: require('../img/icon-lexcellence.png')
    },

]

export const nosSolut = [
    {
        id: "vieww1",
        aria: "view1",
        text: 'Outils sur mesure',
        p: 'Nous développons des outils personnalisés et sur mesure pour vous aider à améliorer votre créativité et votre productivité.',
        p2: "Nous développons des outils personnalisés et sur mesure pour vous aider à améliorer votre créativité et votre productivité en commençant par comprendre vos besoins détaillés, puis en élaborant une solution de qualité adéquate et optimisée. Nos consultants et développeurs maîtrisent plusieurs technologies et langages de programmation permettant ainsi de répondre d'une façon optimale à vos besoins tout en respectant vos contraintes internes.",
        function: () => { document.getElementById("vieww1").classList.add('active'); document.getElementById("vieww2").classList.remove('active'); document.getElementById("vieww3").classList.remove('active'); document.getElementById("vieww4").classList.remove('active'); },
        image: require('../img/solutions-outils.png')
    },
    {
        id: "vieww2",
        aria: "view2",
        text: 'Optimisation de processus',
        p: "Nous analysons vos processus actuels et nous proposons des processus réformés, optimisés et automatisés afin que vos activités soient plus efficaces et effectives et pour répondre aux exigences changeantes du marché.",
        p2: "Nous analysons vos processus actuels, déterminons les axes d'amélioration qui permettent d'apporter des gains en termes de complexité, de délais, de performance et de compatibilité avec d'autres process existants. Nous proposons des processus réformés, optimisés et automatisés afin que vos activités soient plus efficaces et effectives et pour répondre aux exigences changeantes du marché. Nous déterminerons ensemble les technologies à utiliser dans la cible tout en vous proposant les solutions recommandées et prenant en compte vos besoins et les technologies que vous utilisez.",
        function: () => { document.getElementById("vieww1").classList.remove('active'); document.getElementById("vieww2").classList.add('active'); document.getElementById("vieww3").classList.remove('active'); document.getElementById("vieww4").classList.remove('active'); },
        image: require('../img/solutions-optimisation.png')
    },
    {
        id: "vieww3",
        aria: "view3",
        text: 'RPA',
        p: 'Nous vous accompagnons dans vos projets de robotisation afin d’améliorer votre efficacité et la productivité de votre personnel.',
        p2: "Nous vous accompagnons dans vos projets de robotisation afin d’améliorer votre efficacité et la productivité de votre personnel. Nous vous accompagnons dans l'analyse de vos démarches et processus afin d'identifier les pistes d'automatisations en appliquant le RPA. Notre objectif est de maintenir une collaboration continue avec vos équipes pour identifier vos priorités et répondre au mieux à vos besoins.",
        function: () => { document.getElementById("vieww1").classList.remove('active'); document.getElementById("vieww2").classList.remove('active'); document.getElementById("vieww3").classList.add('active'); document.getElementById("vieww4").classList.remove('active'); },
        image: require('../img/solutions-rpa.png')
    },
    {
        id: "vieww4",
        aria: "view4",
        text: 'Edition de logiciel',
        p: 'Nous conceptualisons et nous développons des logiciels pertinents pour améliorer le quotidien de l’utilisateur.',
        p2: "Si vous souhaitez développer un logiciel, nous vous accompagnons dès les premières étapes de conception jusqu'à l'implémentation de votre logiciel. Nous conceptualisons et nous développons des logiciels pertinents et de meilleure qualité pour améliorer le quotidien de l’utilisateur en prenant en main la gestion du projet ainsi que la conception et l'optimisation de la solution. Nos équipes de développement vous accompagnent dans le développement, la recette et le déploiement final du logiciel.",
        function: () => { document.getElementById("vieww1").classList.remove('active'); document.getElementById("vieww2").classList.remove('active'); document.getElementById("vieww3").classList.remove('active'); document.getElementById("vieww4").classList.add('active'); },
        image: require('../img/solutions-edition.png')
    },
]

export const companyConfiance = [
    {
        image: require('../img/cli1.png')
    },
    {
        image: require('../img/cli6.png')
    },
    {
        image: require('../img/cli3.png')
    },
    {
        image: require('../img/cli4.jpg')
    },
    {
        image: require('../img/cli5.jpg')
    },
    {
        image: require('../img/cli2.jpg')
    },
    {
        image: require('../img/cli10.png')
    },
    {
        image: require('../img/cli7.jpg')
    },
    {
        image: require('../img/cli9.png')
    },
    {
        image: require('../img/cli13.png')
    },
    {
        image: require('../img/cli11.jpg')
    },
    {
        image: require('../img/cli12.png')
    },
]

export const teamImages = [
    {
        image: require('../img/teamimage1.JPG'),
        name: "Marie Rose Areiji",
        title: "Data Analyste"
    },
    {
        image: require('../img/teamimage2.JPG'),
        name: "Nassim Youssef",
        title: "Job Title"
    },
    {
        image: require('../img/teamimage3.JPG'),
        name: "Jessica Oueiss",
        title: "Ingénieur Business Process Improvement"
    },
    {
        image: require('../img/teamimage4.JPG'),
        name: "Jason Semaan",
        title: "Web developer"
    },
    {
        image: require('../img/teamimage5.JPG'),
        name: "Badwi Jabbour",
        title: "Ingénieur Business Process Improvement"
    },
    {
        image: require('../img/teamimage6.JPG'),
        name: "Nadim Tawk",
        title: "Ingénieur developeur"
    },
    {
        image: require('../img/teamimage7.JPG'),
        name: "Jacques Karam",
        title: "Consultant Généraliste"
    },
    {
        image: require('../img/teamimage8.JPG'),
        name: "Youssef Geitani",
        title: "Job Title"
    },
    {
        image: require('../img/teamimage9.JPG'),
        name: "Jihad Semaan",
        title: "Ingénieur Business Process Improvement"
    },
    {
        image: require('../img/teamimage10.JPG'),
        name: "Mikhael Tannous",
        title: "Ingénieur Business Process Improvement"

    }
];